// extracted by mini-css-extract-plugin
export default {"subHeader":"_ZRNs","borderless":"alqn9"};